'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import {RelativeContainer} from '../ui/RelativeContainer.js';
import {BoxDisposition, BoxContentControl} from '../content/BoxContent.js';

const privateMap = util.createPrivateMapper();

const handleMousewheelZoom = function(view, boxControl, zoomFactor, ev){
  ev.preventDefault();
  const delta = ev.wheelDelta ? ev.wheelDelta : -ev.detail;
  const pt = new Point2D(ev.clientX, ev.clientY);
  const zpt = boxControl.getViewPoint(domUtil.getPixel(view.domEl, pt));
  boxControl.pointDeltaZoom(delta, zoomFactor, zpt);
  view.requestRender();
};

class DragMove {
  constructor(){
    this.basePosition = new Point2D();
    this.base = new Point2D();
  }
  start(view, boxControl, ev, touch){
    // if (dragDisabled) {
    //   return false;
    // }
    ev.preventDefault();
    view.focus();
    ev.stopPropagation();
    const pt = boxControl.disposition.offset;
    this.touchOffset = new Point2D();
    this.prevTouch = touch;
    this.basePosition.x = pt.x;
    this.basePosition.y = pt.y;
    this.base = touch.center;
    this.dragged = false;
    return true;
  }

  drag(view, boxControl, ev, touch){
    const z = boxControl.disposition.zoom;
    const pTouch = this.prevTouch;
    this.prevTouch = touch;

    let tpDist = 0;
    let tpAng = 0;
    if (touch.points.length != pTouch.points.length) {
      this.touchOffset = pTouch.center.add(this.touchOffset).sub(touch.center);
      tpDist = touch.distance;
      tpAng = touch.angle;
    } else {
      tpDist = pTouch.distance;
      tpAng = pTouch.angle;
    }
    const px = touch.center.add(this.touchOffset);
    const delta = px.sub(this.base).rotate(boxControl.disposition.angle);
    if (delta.distance() > 1) {
      // cancelClick = true;
      this.dragged = true;
    }
    const tPt = boxControl.disposition.offset;
    // if (touch.angle != tpAng) {
    //   const dAng = touch.angle - tpAng;
    //   boxControl.rotate(boxControl.disposition.angle + dAng);
    //   boxControl.move(boxControl.disposition.offset.sub(tPt.sub(tPt.rotate(dAng))));
    // }
    if (touch.distance > 0 && tpDist > 0) {
      const nz = boxControl.normalizeZoom(z * (touch.distance / tpDist));
      if (nz != z) {
        boxControl.pointZoom(nz, boxControl.getViewPoint(pTouch.center));
        boxControl.move(boxControl.disposition.offset.add(touch.center.sub(pTouch.center).rotate(boxControl.disposition.angle)));
        this.basePosition = boxControl.disposition.offset.sub(delta);
      }
    }

    boxControl.move(this.basePosition.add(delta));
    view.requestRender();
  }
}

export class ImageViewControl {
  constructor(argOptions){
    const pv = privateMap(this);
    const options = argOptions ? argOptions : {};
    pv.options = options;
    pv.rotationGap = options.rotationGap ? options.rotationGap : Math.PI / 30;
    pv.moveGap = options.moveGap ? options.moveGap : 20;
    pv.zoomFactor = options.zoomFactor ? options.zoomFactor : 2;
    pv.dragProxy = options.dragProxy ? options.dragProxy : () => false;
    pv.listeners = {}
    pv.touching = false;
    pv.requestRender = function(){};
    // pv.boxControl = new BoxContentControl();

    this.mouseWheelDisabled = false;
    this.dragMoveDisabled = false;
    pv.mousewheelHandler = (ev) => {
      if (this.mouseWheelDisabled || !pv.boxControl) {
        return;
      }
      handleMousewheelZoom(pv.view, pv.boxControl, pv.zoomFactor, ev);
    }

    const drag = new DragMove();
    pv.dragHandler = (ev) => {
      if (this.dragMoveDisabled || !pv.boxControl) {
        return;
      }
      const touch = domUtil.generateTouch(ev)
      if (pv.dragProxy(pv.view, pv.boxControl, ev, touch)) {
        return
      }
      ev.preventDefault()
      drag.start(pv.view, pv.boxControl, ev, touch);
      const moveHandler = (ev) => {
        drag.drag(pv.view, pv.boxControl, ev, domUtil.generateTouch(ev));
      };
      domUtil.addEventListener(window, 'mousemove', moveHandler);

      const endHandler = function(){
        domUtil.removeEventListener(window, 'mousemove', moveHandler);
        domUtil.removeEventListener(window, 'mouseup', endHandler);
      };
      domUtil.addEventListener(window, 'mouseup', endHandler);
      domUtil.addEventListener(window, 'blur', endHandler);
    };
    pv.touchHandler = (ev) => {
      if (this.dragMoveDisabled || !pv.boxControl) {
        return;
      }
      if (pv.touching) {
        return;
      }
      pv.touching = true;
      drag.start(pv.view, pv.boxControl, ev, domUtil.getTouch(ev));
      const moveHandler = (ev) => {
        drag.drag(pv.view, pv.boxControl, ev, domUtil.getTouch(ev));
      };
      domUtil.addEventListener(window, 'touchmove', moveHandler);

      const endHandler = function(ev){
        const touch = domUtil.getTouch(ev);
        if (touch.points.length > 0) {
          return;
        }
        domUtil.removeEventListener(window, 'touchmove', moveHandler);
        domUtil.removeEventListener(window, 'touchend', endHandler);
        pv.touching = false;
      };
      domUtil.addEventListener(window, 'touchend', endHandler);
      domUtil.addEventListener(window, 'blur', endHandler);
    }
    // pv.clickHandler = (ev) => {
    //   console.log(pv.cancelClick);
    //   if (pv.cancelClick) {
    //     pv.cancelClick = false;
    //     ev.stopPropagation();
    //   }
    // }

    pv.contentChangeHandler = (ev) => {
      const pv = privateMap(this);
      // pv.dragControl.target = null;
      // domUtil.removeEventListener(pv.view.eventLayer, 'click', pv.clickHandler);
      domUtil.removeEventListener(pv.view.eventLayer, 'mousewheel', pv.mousewheelHandler);
      domUtil.removeEventListener(pv.view.eventLayer, 'mousedown', pv.dragHandler);
      domUtil.removeEventListener(pv.view.eventLayer, 'touchstart', pv.touchHandler);
      pv.boxControl = null;
      if (pv.view && pv.view.resource) {
        pv.boxControl = pv.view.control.box;
        // domUtil.addEventListener(pv.view.eventLayer, 'click', pv.clickHandler);
        domUtil.addEventListener(pv.view.eventLayer, 'mousewheel', pv.mousewheelHandler);
        domUtil.addEventListener(pv.view.eventLayer, 'mousedown', pv.dragHandler);
        domUtil.addEventListener(pv.view.eventLayer, 'touchstart', pv.touchHandler);
        if (pv.boxControl) {
          for (let nm in pv.listeners) {
            pv.boxControl.addEventListener(nm, pv.listeners[nm]);
          }
        }
        if (options.components) {
          util.each(options.components, (component) => {
            component.link(pv.view);
          });
        }
      }
      pv.requestRender();
    }
    if (options.components) {
      util.each(options.components, (component) => {
        const clickAction = component.domEl.getAttribute('data-click-action');
        if (clickAction) {
          domUtil.addEventListener(component.domEl, 'click', (ev) => {
            ev.preventDefault();
            if (!this[clickAction]) {
              return;
            }
            this[clickAction]();
          })
        }
      });
    }
    this.unlink();
  }

  set viewSize(sz){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.viewSize = sz;
  }

  set resource(resource){
    const pv = privateMap(this);
    pv.boxControl.boxSize = resource.bounds.size;
    console.log('ImaveViewControl resource.boundaryBoxSize', resource.boundaryBoxSize)
    pv.boxControl.boundaryBoxSize = resource.boundaryBoxSize;
    // pv.boxControl.disposition.bounds.position.set(0, 0);
    // pv.boxControl.disposition.bounds.size.set(resource.size);
  }

  link(view) {
    const pv = privateMap(this);
    if (pv.view) {
      this.unlink();
    }
    pv.view = view;
    if (!pv.view) {
      return;
    }
    // pv.boxControl = view.renderer.boxControl;
    domUtil.addEventListener(pv.view.eventLayer, 'ui.contentchange', pv.contentChangeHandler);
    this.viewSize = view.size;
    pv.requestRender = function(){
      view.requestRender();
    };
  }

  unlink(){
    const pv = privateMap(this);
    if (pv.view) {
      domUtil.removeEventListener(pv.view.eventLayer, 'mousewheel', pv.mousewheelHandler);
      domUtil.removeEventListener(pv.view.eventLayer, 'mousedown', pv.dragHandler);
      domUtil.removeEventListener(pv.view.eventLayer, 'ui.contentchange', pv.contentChangeHandler);
    }
    if (pv.boxControl) {
      for (let nm in pv.listeners) {
        pv.boxControl.removeEventListener(nm, pv.listeners[nm]);
      }
    }
    if (pv.options.components) {
      util.each(pv.options.components, (component) => {
        component.unlink();
      });
    }
    pv.requestRender = function(){};
    pv.view = null;
    pv.boxControl = null;
  }

  zoom(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.zoom.apply(pv.boxControl, arguments);
    pv.requestRender();
  }

  move(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.move.apply(pv.boxControl, arguments);
    pv.requestRender();
  }

  moveBy(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.moveBy.apply(pv.boxControl, arguments);
    pv.requestRender();
  }

  rotate(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.rotate.apply(pv.boxControl, arguments);
    pv.requestRender();
  }

  rotateBy(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.rotateBy.apply(pv.boxControl, arguments);
    pv.requestRender();
  }

  rotateLeft(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    this.rotateBy(-pv.rotationGap);
  }

  rotateRight(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    this.rotateBy(pv.rotationGap);
  }

  moveLeft(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    this.moveBy(pv.moveGap, 0);
  }
  moveRight(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    this.moveBy(-pv.moveGap, 0);
  }
  moveUp(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    this.moveBy(0, pv.moveGap);
  }
  moveDown(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    this.moveBy(0, -pv.moveGap);
  }

  zoomIn(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.deltaZoom(1, pv.zoomFactor);
    pv.requestRender();
  }

  zoomOut(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.deltaZoom(-1, pv.zoomFactor);
    pv.requestRender();
  }

  fit(dir){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.fit(dir);
    pv.requestRender();
  }

  home(){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.rotate(0)
    this.fit()
  }

  fitRect(box){
    const pv = privateMap(this);
    if (!pv.view || !pv.boxControl) {
      return;
    }
    pv.boxControl.fitRect(box);
    pv.requestRender();
  }
};
